/** Formata comprimento em metros (ol/sphere getLength). */
export function formatMapLength(meters) {
  const n = Number(meters);
  if (!Number.isFinite(n) || n < 0) return '—';
  if (n >= 1000) return `${(n / 1000).toFixed(2)} km`;
  return `${Math.round(n)} m`;
}

/** Formata área em m² (ol/sphere getArea). */
export function formatMapArea(sqMeters) {
  const n = Number(sqMeters);
  if (!Number.isFinite(n) || n < 0) return '—';
  if (n >= 10_000) return `${(n / 10_000).toFixed(2)} ha`;
  return `${Math.round(n)} m²`;
}

export function eventTimeMs(value) {
  if (!value) return null;
  const ms = new Date(value).getTime();
  return Number.isNaN(ms) ? null : ms;
}
